<form [formGroup]="form" id="{{ baseId }}-modal-form" class="general-form" #modalForm="ngForm" (ngSubmit)="onApply()">
  <div class="emds">
    <div class="modal-default modal-flex">
      <div class="modal-header">
        <span>Filter {{fcFilterModalContext.findControlConfig.FindControlBehavior.Name}}</span>
      </div>

      <div class="modal-body">
        <ng-container *ngIf="isLoading">
          <div class="text-center">
            <ap-spinner size="2"></ap-spinner>
          </div>
        </ng-container>

        <ng-container *ngIf="!isLoading">
          <ng-content></ng-content>
        </ng-container>
      </div>

      <div class="modal-footer">
        <button type="submit" id="{{ baseId }}-apply-btn" class="btn btn-primary" translate>
          Apply
        </button>
        <button type="button" id="{{ baseId }}-clear-btn" class="btn btn-light" (click)="onClear()" [disabled]="disableClear" translate>
          Clear
        </button>
        <button type="button" id="{{ baseId }}-cancel-btn" class="btn btn-secondary btn-flush-right" (click)="onCancel()" translate>
          Cancel
        </button>
      </div>
    </div>
  </div>
</form>
